export default __webpack_public_path__ + "static/media/gallery-wip-neck_02.f57a9e5d.jpg";